<template>
	<el-dialog title="" :visible.sync="createdVisible" width="578px" center :close-on-click-modal="false" @close="onResetForm('ruleForm')">
		<div slot="title" class="postion">
			<i v-if="!isShowDetail" class="iconfont icon-bianji1"></i>
			<span class="download">{{ isShowDetail ? '查看' : !isShowDetail && ruleForm.id ? '编辑' : '新增' }}巡诊组</span>
		</div>
		<el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="巡诊组名称" prop="name">
				<el-input v-model.trim="ruleForm.name" clearable :disabled="isShowDetail" placeholder=" 请输入" maxlength="20"></el-input>
			</el-form-item>
			<el-form-item label="负责人" prop="principalName" class="w50 mr16">
				<el-input v-model.trim="ruleForm.principalName" clearable :disabled="isShowDetail" placeholder=" 请输入" maxlength="20"></el-input>
			</el-form-item>
			<el-form-item label="" prop="phoneNumber" class="w50 mr0">
				<el-input v-model.trim="ruleForm.phoneNumber" clearable :disabled="isShowDetail" placeholder=" 联系电话" maxlength="11"></el-input>
			</el-form-item>
			<el-form-item label="添加成员" prop="userList">
				<div class="users-item" v-for="(item, index) in ruleForm.userList" :key="index">
					<el-select v-model="item.name" placeholder="成员" @change="changeUser($event, item, index)" :disabled="isShowDetail">
						<el-option v-for="item in option" :disabled="!item.enabled" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-select v-model="item.agency" placeholder="机构" disabled>
						<el-option v-for="item in option" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
					<el-select v-model="item.type" placeholder="类型" disabled>
						<el-option v-for="item in option" :key="item.id" :label="item.title" :value="item.code"></el-option>
					</el-select>
					<i class="iconfont icon-tianjia3" @click="onNew(index)" v-if="!isShowDetail"></i>
					<i class="iconfont icon-a-shanchu2" @click="onDelete(index, item)" v-if="ruleForm.userList.length > 1 && !isShowDetail"></i>
				</div>
			</el-form-item>
			<el-form-item class="func-btn">
				<el-button @click="onResetForm('ruleForm')" type="primary" v-if="isShowDetail">确 定</el-button>
				<el-button v-else type="primary" @click="onSave('ruleForm')">保存</el-button>
				<el-button v-if="!isShowDetail" @click="onResetForm('ruleForm')">取消</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
import { verifyPhone } from '@/utils/toolsValidate';
export default {
	components: {
		Upload: () => import('@/components/Upload/index.vue'),
		RsForm: () => import('@/components/RsForm/index.vue'),
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系方式'));
			} else if (!verifyPhone(value)) {
				callback(new Error('请输入正确的联系方式'));
			} else {
				callback();
			}
		};
		return {
			ruleForm: { userList: [{ name: '' }] },
			createdVisible: false,
			rules: {
				name: [{ required: true, message: '请输入', trigger: 'blur' }],
				principalName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				phoneNumber: [{ required: true, validator: checkPhone, trigger: 'blur' }],
				userList: [{ type: 'array', required: true, message: '请至少选择一个成员', trigger: 'blur' }],
			},
			saveLoading: false,
			link: '',
		};
	},
	props: ['isShowDetail', 'option'],
	watch: {},
	created() {},
	methods: {
		onSave(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveLoading = true;
					let params = {
						...this.ruleForm,
						discriminationCode: 'T',
						medicalWorkerIds: this.ruleForm.userList.filter((v) => v.id && v.id != '').map((item) => item.id),
					};
					let queryApi = this.ruleForm.id ? this.$http.put(this.link, params) : this.$http.post(this.link, params);
					queryApi
						.then((res) => {
							if (res.data && res.data.success) {
								this.saveLoading = false;
								this.$message.success(this.ruleForm.id ? '修改成功' : '添加成功');
								this.$emit('getList');
								this.onResetForm('ruleForm');
							}
						})
						.catch(() => {
							this.saveLoading = false;
						});
				}else {
					this.$nextTick(() => {
						let isError = document.getElementsByClassName('is-error');
						// var a = $(isError[0]).find("input") //this.$refs.cmd.$el.querySelector('input')
						// a.focus()  光标定位到所在input
						isError[0].scrollIntoView({
							// 滚动到指定节点
							// 值有start,center,end，nearest
							block: 'center',
							// 值有auto、instant,smooth，缓动动画
							behavior: 'smooth',
						});
					});
					return false;
				}
			});
		},
		// 新增成员
		onNew(index) {
			this.ruleForm.userList.push({ name: '', type: '', agency: '', id: '' });
			this.$forceUpdate();
		},
		onDelete(index, item) {
			this.option.find((v) => v.id == item.id) ? (this.option.find((v) => v.id == item.id).enabled = true) : '';
			this.ruleForm.userList.splice(index, 1);
			this.$forceUpdate();
		},
		changeUser(id, item, index) {
			if (!id || id === '') return;
			const selectItem = this.option.find((it) => it.id == id);
			selectItem.enabled = false;
			selectItem.name = selectItem.name;
			selectItem.agency = selectItem.medicalOrganization?.title;
			selectItem.type = selectItem.practiceCategoryDictionaryItem?.title;
			this.ruleForm.userList[index] = JSON.parse(JSON.stringify(selectItem));
			this.option.forEach((v) => {
				let resInd = this.ruleForm.userList.findIndex((iter) => iter.id === v.id);
				if (resInd === -1) {
					v.enabled = true;
				}
			});
			this.$forceUpdate();
		},
		init(params) {
			this.createdVisible = true;
			this.link = params.link;
			if (params.row) {
				this.getDetails(params.row);
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate();
				});
				return;
			}
			// 新增
			this.ruleForm = this.$options.data().ruleForm; //清空表单
			this.$nextTick(() => {
				this.$refs.ruleForm.clearValidate();
			});
		},
		getDetails(data) {
			this.ruleForm = JSON.parse(JSON.stringify(data));
			this.ruleForm.userList = [];
			data.medicalWorkers?.length > 0
				? data.medicalWorkers.forEach((item) => {
						let resInd = this.option.findIndex((iter) => iter.id === item.id);
						if (resInd !== -1) {
							this.option[resInd].enabled = false;
							this.ruleForm.userList.push({
								name: this.option[resInd].name,
								type: this.option[resInd].practiceCategoryDictionaryItem?.title,
								agency: this.option[resInd].medicalOrganization?.title,
								id: this.option[resInd].id,
							});
						}
				  })
				: !this.isShowDetail
				? (this.ruleForm.userList = [])
				: (this.ruleForm.userList = [{ name: '' }]);
		},
		// 重置
		onResetForm(formName) {
			this.createdVisible = false;
			this.$refs[formName].resetFields();
		},
	},
};
</script>

<style lang="scss" scoped>
.showBorder {
	border: 1px solid red;
}
.postion {
	font-size: 18px;
	.icon-bianji1 {
		margin-right: 16px;
		color: #1db9b1;
	}
}
/deep/ .el-form {
	.el-form-item {
		.el-select,
		.el-input {
			width: 100%;
		}
	}

	.el-form-item__label {
		line-height: 14px;
		height: 14px;
		margin-bottom: 8px;
		padding: 0;
	}
}
/deep/ .el-button {
	margin-left: 16px;
}
.users-item {
	margin-bottom: 12px;
	display: grid;
	grid-template-columns: 136px 136px 136px 16px 16px;
	gap: 15px;
	i {
		line-height: 32px;
		color: #999;
		font-size: 16px;
		cursor: pointer;
	}
	i:hover {
		color: #1db9b1;
	}
	.icon-shanchu:hover {
		color: #f56c6c;
	}
}
.users-item:nth-last-child(1) {
	margin-bottom: 0;
}
.func-btn /deep/ .el-form-item__content {
	display: flex;
	justify-content: center;
}
.flex-tow {
	display: flex;
	align-items: center;
}
/deep/ .mr0 {
	margin-right: 0 !important;
}
/deep/ .w50 {
	width: calc(50% - 8px);
	display: inline-block;
}
</style>